import React from 'react';
import { Col, Flex, Row, Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'common/config/dayjs.config';
import { ERoutesCommon } from 'common/models/routesModel';
import bitecoinsInWallet from 'app/assets/images/bitecoinsInWallet.png';
import { useAppSelector } from 'app/store/store.hooks';
import { ReactComponent as BitecoinIcon } from 'app/assets/images/bitecoinIcon.svg';
import { ReactComponent as ExclamationMark } from 'app/assets/images/exclamationMark.svg';
import { BITECOIN_AMOUNT_WARNING_PERCENT } from 'entities/Bitecoin/Bitecoin.const';
import { ReferAFriendBlock, ReferAFriendPlaceholder } from 'entities/Referral/components/ReferAFriendBlock';

export const BitecoinWalletBalanceWidget: React.FC = () => {
  const navigate = useNavigate();
  const { authModelLoading } = useAppSelector((state) => state.auth);
  const { customerModel, customerModelLoading } = useAppSelector((state) => state.customer);
  const { bitecoinCustomerInfoModel } = useAppSelector((state) => state.bitecoin);

  if (!authModelLoading && !customerModelLoading && !customerModel) {
    navigate(ERoutesCommon.Root);

    return null;
  }

  if (!bitecoinCustomerInfoModel) {
    return null;
  }

  const { bitecoins, expiredAt, bitecoinsLimit } = bitecoinCustomerInfoModel;

  const tooltipText = bitecoins
    ? `Bitecoins will expire on ${dayjs(expiredAt).format('MMMM D, YYYY')}`
    : 'Order from the menu to get first bitecoins!';
  const showWarning = bitecoins >= bitecoinsLimit * BITECOIN_AMOUNT_WARNING_PERCENT;
  const warningText =
    bitecoins === bitecoinsLimit
      ? 'You`ve reached the limit of your Bitecoin Wallet! Redeem Rewards to continue earning more Bitecoins.'
      : `You will reach the ${bitecoinsLimit} coin limit of your Bitecoin Wallet soon!`;

  return (
    <div className="store-panel">
      <div className="store-panel__container">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={16} lg={16}>
            <div className="bitecoin-wallet__balance-widget">
              {/* Same T&C info-icon as the announcements panel: top-right corner, icon-only, opens ToS. */}
              <Tooltip title="Terms & Conditions applied">
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  to={ERoutesCommon.ToS}
                  className="bitecoin-wallet__balance-widget__info"
                >
                  <InfoCircleFilled />
                </Link>
              </Tooltip>
              <Row justify="space-between" wrap={false}>
                <Col className="mt-8 ml-7 mr-7 mb-8">
                  <Flex vertical justify="space-between" className="height-full">
                    <span>Your balance</span>
                    <Row align="middle">
                      <BitecoinIcon />
                      <span className="bitecoin-wallet__balance-widget__sum">{bitecoins}</span>
                    </Row>
                    <span className="bitecoin-wallet__balance-widget__tooltip">{tooltipText}</span>
                  </Flex>
                </Col>
                <Col>
                  <img src={bitecoinsInWallet} width={200} alt="bitecoins" />
                </Col>
              </Row>
              {/* Figma 14483:11827: friend-code block lives inside the brown balance card. */}
              <ReferAFriendBlock />
            </div>
            {/* Figma 14513:17682: the no-orders banner is a standalone plate BELOW the card. */}
            <ReferAFriendPlaceholder />
          </Col>
          <Col xs={24} sm={8} lg={8}>
            {showWarning && (
              <Row wrap={false} className="bitecoin-wallet__balance-warning">
                <Col>
                  <ExclamationMark fill="#ffffff" className="mr-2" />
                </Col>
                <Col>
                  <span>{warningText}</span>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};
